var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CarouselIndex',{key:_setup.ids,attrs:{"data-cy":"latest-sales","title":_vm.$t('general.latestSales'),"subtitle":`${_vm.$t('general.latestSalesheading')} ${_setup.urlPrefix}`,"nfts":_setup.nfts,"action-type":"pagination"}})
}
var staticRenderFns = []

export { render, staticRenderFns }